<template>
    <v-layout row class="align-center layout px-4 py-1 app--page-header">
        <div class="page-header-left">
            <h3 class="pr-3">{{ title }}</h3>
        </div>
        <v-breadcrumbs divider="-" :items="breadcrumbs">
            <template v-slot:item="props">
                <router-link v-if="props.item.home" :to="props.item.href" class="enabled">
                    <v-icon small color="primary">fa-home</v-icon>
                </router-link>

                <a v-else-if="props.item.disabled" class="disabled">
                    {{ props.item.text }}
                </a>

                <router-link v-else :to="props.item.href" class="enabled">
                    {{ props.item.text }}
                </router-link>
            </template>
        </v-breadcrumbs>
    </v-layout>
</template>

<script>
import menu from "@/api/menu"
import { mapGetters } from "vuex"

export default {
    data() {
        return {
            title: ""
        }
    },
    computed: {
        ...mapGetters(["BREADCRUMB"]),
        breadcrumbs: function() {
            let breadcrumbs = []
            let isMenuItem = false
            var app = this

            // agregando elemento de inicio al breadcrumb
            breadcrumbs.push({
                home: true,
                href: "/dashboard"
            })

            if (this.BREADCRUMB === null) {
                menu.forEach(item => {
                    if (item.items) {
                        let child = item.items.find(i => {
                            return i.component === app.$route.name
                        })
                        if (child) {
                            breadcrumbs.push({
                                text: item.title,
                                disabled: true
                            })
                            breadcrumbs.push({
                                text: child.title,
                                disabled: true
                            })
                            app.title = child.title
                            isMenuItem = true
                        }
                    } else {
                        if (item.name === app.$route.name) {
                            app.title = item.title
                            breadcrumbs.push({
                                text: item.title,
                                disabled: true
                            })
                            isMenuItem = true
                        }
                    }
                })

                if (!isMenuItem) {
                    app.title = app.$route.meta.title

                    if (app.$route.meta.parentMenu) {
                        let parent = null

                        menu.forEach(e => {
                            if (e.name === app.$route.meta.parentMenu) {
                                parent = e
                            } else if (e.items) {
                                let subparent = e.items.find(i => {
                                    return i.component === app.$route.meta.parentMenu
                                })
                                if (subparent) {
                                    breadcrumbs.push({
                                        text: e.title,
                                        disabled: true
                                    })

                                    parent = subparent
                                }
                            }
                        })

                        if (parent) {
                            breadcrumbs.push({
                                text: parent.title,
                                href: { name: parent.component }
                            })
                        }
                    }

                    breadcrumbs.push({
                        text: app.$route.meta.title,
                        disabled: true
                    })
                }
            } else {
                app.title = app.$route.meta.title
                this.BREADCRUMB.forEach(el => {
                    breadcrumbs.push(el)
                })
            }

            return breadcrumbs
        }
    }
}
</script>

<style lang="stylus" scoped>
.disabled
    color: grey
    pointer-events: none

.enabled
    text-decoration: none
</style>
